import type { DeleteIndicatorsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  deletedIds: string[]
): DeleteIndicatorsMutation => {
  return {
    delete_indicator_result: {
      __typename: 'indicator_result_mutation_response',
      affected_rows: 0,
    },
    delete_indicator: {
      __typename: 'indicator_mutation_response',
      affected_rows: deletedIds.length,
    },
  };
};

export const useDeleteIndicatorsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.indicator.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.indicator.indicatorById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.indicator.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.indicator.indicatorsByParentId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteIndicators: async (
      ids: string[]
    ): Promise<DeleteIndicatorsMutation> => {
      await mutation.mutateAsync({ ids });

      return mapTrpcResponseToGraphQL(ids);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
